/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/050-folder-plus': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M9 4L7 2H0v13h16V4H9zm2 7H9v2H7v-2H5V9h2V7h2v2h2v2z"/>'
  }
})
